import { render, staticRenderFns } from "./slider-left-icon.vue?vue&type=template&id=acd2ad06&scoped=true"
import script from "./slider-left-icon.vue?vue&type=script&lang=js"
export * from "./slider-left-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd2ad06",
  null
  
)

export default component.exports